import Pagination from "react-bootstrap/Pagination";

function Pager({ page, totalPages, onPage }) {

  if (totalPages <= 1) {
    return null;
  }

  let items = [];
  for (let i=1; i<=totalPages; i++) {
    const isActive = (i === page);
    items.push(
      <Pagination.Item
        key={i}
        active={isActive}
        onClick={() => onPage(i)}
      >
        {i}
      </Pagination.Item>,
    );
  }

  return (
    <Pagination className="d-flex flex-row flex-wrap justify-content-center" size="md">{items}</Pagination>
  );

}

export default Pager;
